import { z } from "zod";
import { type ParserType, parser } from "./parser";

// TODO: zod-utils
export type HexColor = ParserType<typeof HexColor>;

export const HexColor = parser(
  z.stringFormat("hex-color", /^#[0-9a-f]{6}$/i).brand("HexColor"),
);
